{
  "de": {
    "client": {
      "actions": {
        "changeBackgroundImage": "Login-Bild ändern",
        "new": "Neuer Mandant",
        "setAsPrimary": "Als primär festlegen",
        "submit": "Absenden",
        "undoChanges": "Änderungen rückgängig machen"
      },
      "attributes": {
        "address": "Adresse",
        "aftercare_conversation_enabled": "Nachbetreuungskonversationen",
        "backgroundImage": "Login-Bild",
        "email_address": "E-Mail",
        "email_address_reply_to": "„Antwort an“-E-Mail-Adresse",
        "email_address_ziggu": "„Von“-E-Mail-Adresse",
        "iban": "IBAN",
        "language": "Sprache",
        "languages": "Organisationssprachen",
        "name": "Name",
        "phone": "Telefon",
        "subdomain": "Subdomain",
        "timezone": "Zeitzone",
        "vat_number": "USt-IdNr."
      },
      "client_types": {
        "architects_designers": "Architekten & Designer",
        "creative_agencies": "Kreativagenturen",
        "general_specialized_contractors": "Generalunternehmer & Fachunternehmer",
        "makers_manufacturers": "Hersteller & Handwerker",
        "planners_coordinators": "Planer & Koordinatoren",
        "property_developers": "Bauträger"
      },
      "integrations": {
        "api_docs_info": "Weitere Informationen zu unserer API finden Sie in unserer",
        "api_documentation": "API-Dokumentation"
      },
      "labels": {
        "after_care_categories": "Kategorien",
        "after_care_statuses": "Status",
        "aftercare": "Nachbetreuung",
        "bookADemo": "Demo buchen",
        "by": "Von {client}",
        "categories": "Kategorien",
        "category": "Kategorie",
        "chatWithUs": "Chatten Sie mit uns",
        "companyProfile": "Organisationsprofil",
        "contactIntercom": "Kontaktieren Sie uns über den Chat, wenn Sie dies ändern möchten.",
        "contactZiggu": "Haben Sie eine Frage an Ziggu? Kommen Sie nicht weiter? Möchten Sie uns Produkt-Feedback geben? Lassen Sie uns chatten!",
        "conversations": "Konversationen",
        "dashboard": "Dashboard",
        "decisions": "Entscheidungen",
        "default_payment_overdue": "Sie haben eine überfällige Rechnung bei Ziggu. Bitte begleichen Sie diese umgehend, um Zinsen zu vermeiden. Haben Sie Fragen? Kontaktieren Sie uns gerne.",
        "delete_category": "Kategorie {category} löschen?",
        "delete_category_expl": "Das Löschen einer Dokumentkategorie kann nicht rückgängig gemacht werden. Vorhandene Dokumente mit dieser Kategorie werden auf die Kategorie Sonstiges geändert",
        "document_categories": "Kategorien",
        "documents": "Dokumente",
        "edit_document_category": "Kategorie bearbeiten",
        "email_address_reply_to": "Diese E-Mail-Adresse wird verwendet, wenn jemand auf eine über {email_address_ziggu} gesendete E-Mail antwortet. Kontaktieren Sie uns über den Chat, wenn Sie dies ändern möchten.",
        "email_address_ziggu": "Diese E-Mail-Adresse wird als Absenderadresse (FROM) für alle über die Plattform gesendeten E-Mails verwendet (E-Mails zu Benachrichtigungen, Einladungen, Passwort-Zurücksetzungen usw.)",
        "email_forwarder_must_be_owner": "Nur Teammitglieder mit der Rolle „Inhaber“ können E-Mails weiterleiten.",
        "email_forwarding_activated": "E-Mail-Weiterleitung ist aktiv",
        "email_forwarding_activated_project": "Projekt-E-Mail-Weiterleitung ist aktiv",
        "email_forwarding_disclaimer": "Um Spam zu vermeiden, werden nur E-Mails verarbeitet, die von einer Adresse gesendet werden, die mit einem <b>bestehenden Inhaber- oder Projektbetreuer-Profil</b> verknüpft ist.<br>E-Mails von unbekannten Absendern werden ignoriert.",
        "email_forwarding_is": "Ihre Weiterleitungsadresse lautet",
        "financials": "Finanzen",
        "general": "Allgemein",
        "goToSettings": "Einstellungen",
        "helpcenter": "Hilfecenter",
        "inbound_email": "Eingehende E-Mail",
        "invoice_overdue": "Sie haben eine überfällige Zahlung. Bitte kontaktieren Sie accounting{'@'}ziggu.io für weitere Informationen.",
        "invoice_overdue_title": "Rechnung überfällig",
        "language": "Dies ist die Standardsprache der Organisation für Ihre Login-Seite, Kunden und Teammitglieder.",
        "languages": "Die primäre Sprache ist die Standardsprache für die Inhaltseingabe und kann nicht entfernt werden. Fügen Sie weitere Sprachen hinzu, um mehrsprachige Inhalte zu unterstützen. Klicken Sie auf eine zusätzliche Sprache, um sie als primär festzulegen.",
        "mobile_app_disabled": "Mobile App (PWA) nicht aktiv",
        "mobile_app_enabled": "Mobile App (PWA) aktiv",
        "mobile_app_info": "Schreiben Sie uns über Intercom für weitere Informationen!",
        "mustBeJPG": "Muss ein .jpg-Bild sein",
        "new_categories": "Zusätzliche Kategorien",
        "new_document_category": "Kategorie",
        "noCategories": "Sie haben noch keine Kategorien. Erstellen Sie eine, um loszulegen.",
        "other": "Sonstiges",
        "outOfOffice": "Abwesenheit",
        "outOfOfficeMessage": "Abwesenheitsnachricht (optional)",
        "primary": "Primär",
        "removed_user": "Entfernter Nutzer",
        "settings": {
          "click_to_copy": "Klicken, um Token in die Zwischenablage zu kopieren",
          "copied_to_clipboard": "Token in die Zwischenablage kopiert"
        },
        "snippets": "Textbausteine",
        "subscription": "Abonnement",
        "tab_aftercare": "Nachbetreuung",
        "tab_billing": "Abrechnung",
        "tab_branding": "Branding",
        "tab_features": "Funktionen",
        "tab_general": "Allgemein",
        "tab_information": "Informationen",
        "tab_integrations": "Integrationen",
        "tickets": "Konversationen",
        "timezone": "Dies ist die Standardzeitzone der Organisation.",
        "translation_not_added_yet": "Übersetzung wurde noch nicht hinzugefügt",
        "unchangeable_categories": "Standardkategorien, die nicht geändert werden können",
        "unchangeable_categories_info": "Diese Kategorien werden benötigt, damit das System ordnungsgemäß funktioniert, oder werden in Integrationen verwendet.",
        "warningooo": "Abwesenheit aktiv",
        "yourEmail": "Ihre E-Mail",
        "zigguHome": "Ziggu Startseite"
      },
      "toasts": {
        "attachment_category": {
          "create": "Dokumentkategorie erstellt",
          "update": "Dokumentkategorie wurde aktualisiert"
        }
      },
      "validation": {
        "mustBeEmailAddress": "Muss eine E-Mail-Adresse sein",
        "needName": "Name ist erforderlich"
      }
    }
  }
}
